import { Injectable } from '@angular/core';
import { WebApiService } from 'src/app/shared/services/web-api.service';
import { ApiUrlConstants } from 'src/app/shared/common/ApiUrlConstants';

@Injectable({
  providedIn: 'root',
})
export class SupplierServiceInvoiceListService {
  constructor(private webApiService: WebApiService) {}

  fetchSupplierServiceInvoiceStatusSummary(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchSupplierServiceInvoiceStatusSummary,
      reqBody
    );
  }

  fetchSupplierServiceInvoiceLists(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchSupplierServiceInvoiceLists,
      reqBody
    );
  }

  fetchArchivedSupplierServiceInvoiceLists(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.fetchArchivedSupplierServiceInvoiceLists,
      reqBody
    );
  }

  exportAllSupplierServiceInvoiceList(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.exportAllSupplierServiceInvoiceList,
      reqBody
    );
  }

  supplierServiceInvoiceListsOperations(reqBody: any) {
    return this.webApiService.postRequest<any>(
      ApiUrlConstants.supplierServiceInvoiceListsOperations,
      reqBody
    );
  }
}
